module.exports = __webpack_public_path__ + "static/media/MuseoSansLight.3258ca8b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/MuseoSansLight/MuseoSansLight.ttf
// module id = 641
// module chunks = 0